import React from "react";
import * as XLSX from "xlsx";

const ExcelUpload = ({ onDataLoaded }) => {
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const formattedData = data.slice(1).map((row) => ({
        itemCode: row[0] || "",
        categoryName: row[1] || "",
        itemName: row[2] || "",
        unit: row[3] || "",
        pcsPerCtn: row[4] || "",
        wtPerCtn: row[5] || "",
        cbmPerCtn: row[6] || "",
        itemImageLink: row[7] || "",
      }));
      onDataLoaded(formattedData.filter((item) => item.itemCode)); // Filter out empty rows
    };
    reader.readAsBinaryString(file);
  };

  return (
    <div className="flex flex-col">
      <label className="text-xs font-medium text-gray-600 mb-1">
        Upload Excel File
      </label>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        className="text-sm text-gray-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-600 file:text-white hover:file:bg-blue-700 file:transition-colors"
      />
    </div>
  );
};

export default ExcelUpload;
